import React from 'react';

import { THEME } from '../constants';
import useSettingsState from '../hooks/useSettingsState';

const initialState = {
  theme: THEME.DEFAULT,
  setTheme: (layout: string) => {},
};

const ThemeContext = React.createContext(initialState);

interface ThemeProviderType {
  children: React.ReactNode;
}

function ThemeProvider({ children }: ThemeProviderType) {
  const localTheme = localStorage.getItem('theme');
  const [theme, setTheme] = useSettingsState('theme', localTheme ?? THEME.DEFAULT);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export { ThemeProvider, ThemeContext };
